"use client";

import { c as _c } from "react/compiler-runtime";
import { ViewTransition } from "react";
import Routes from "@/constants/Routes";
import { Badge } from "@/components/ui/badge";
import { Link } from "@/components/ui/link";
import { formatRelativeDate } from "@/lib/date";
import { Card, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { useBlogs } from "@/features/rants/hooks/use-blogs";
import Image from "next/image";
type BlogsProps = {
  tags: string[];
  allTags: string[];
};
function Blogs(t0) {
  const $ = _c(8);
  const {
    tags,
    allTags
  } = t0;
  const {
    blogs
  } = useBlogs(tags);
  if (!blogs) {
    return null;
  }
  let t1;
  if ($[0] !== allTags || $[1] !== tags) {
    t1 = allTags.length > 0 ? <div className="flex flex-row flex-wrap gap-2 pb-4">{Array.from(allTags).map(tag => {
        const isSelected = tags.includes(tag);
        const set = new Set(tags);
        if (isSelected) {
          set.delete(tag);
        } else {
          set.add(tag);
        }
        return <Link key={tag} href={Routes.RANTS_WITH_TAGS(Array.from(set))} replace={true}><Badge variant={tags.includes(tag) ? "default" : "secondary"}>{tag}</Badge></Link>;
      })}</div> : null;
    $[0] = allTags;
    $[1] = tags;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== blogs) {
    t2 = blogs.map(_temp);
    $[3] = blogs;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = <>{t1}{t2}</>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}
function _temp(article) {
  return <article key={article.slug}><Card><Link href={`/rants/${article.slug}`}><CardHeader className="justify-start"><div className="flex flex-col-reverse gap-4 sm:flex-row"><div className="flex flex-1 flex-col gap-6"><div className="flex flex-col gap-2"><ViewTransition name={`blog-article-date-${article.slug}`}><p className="text-xs font-semibold">{formatRelativeDate(article.date)}</p></ViewTransition><ViewTransition name={`blog-article-title-${article.slug}`}><CardTitle>{article.title}</CardTitle></ViewTransition></div><CardDescription>{article.description}</CardDescription></div><div className="relative flex h-32 w-32"><Image priority={true} className="rounded-sm object-cover" src={article.image.src} alt={article.image.alt} height={256} width={256} /></div></div></CardHeader></Link></Card></article>;
}
export default Blogs;